import styled from '@emotion/styled';
import { ChevronDown } from 'lucide-react';

interface NotificationHeaderType { 
    isOpen: boolean;
}

export const NotificationHeader = styled('div', { label: 'NotificationHeader' })`
    display: flex;
    align-items: center;
    gap: 0 8px;
    cursor: pointer;
    padding: 16px 8px;

    svg {
        width: 20px;
        height: 20px;
    }
`;

export const NotificationHeaderArrowIcon = styled(ChevronDown, { label: 'NotificationHeaderArrowIcon' })<NotificationHeaderType>`
    transition: transform .3s ease-in-out;
    transform: ${({ isOpen }): string => isOpen ? 'rotate(0)' : 'rotate(180deg)'};
`;

export const NotificationHeaderName = styled('span', { label: 'NotificationHeaderName' })`
    flex: 1 0 0%;
`;

interface NotificationsMenuWrapperPropsType {
    isOpen: boolean;
}

/* stylelint-disable */
export const NotificationsMenuWrapper = styled('div', { label: 'NotificationsMenuWrapper' })<NotificationsMenuWrapperPropsType>`
    background: hsl(var(--muted));
    flex: 0 0 200px;
    width: 200px;
    padding: 20px 12px 12px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: -300px;
    transform: ${({ isOpen }): string => isOpen ? 'translateX(388px)' : 'translateX(0)'};
    transition: transform 0.2s ease;
    overflow-y: auto;

    display: flex;
    flex-direction: column;

    z-index: 1;
`;

export const NotificationItemContainer = styled('div', { label: 'NotificationItemContainer' })`
    display: contents;
`;

export const NotificationDot = styled('div', { label: 'NotificationDot' })<NotificationsMenuWrapperPropsType>`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${({ isOpen }): string => isOpen ? '#fff' : 'hsl(var(--primary))'};
    position: absolute;
    top: 6px;
    right: 26px;
    border: ${({ isOpen }): string => isOpen ? '2px solid hsl(var(--primary))' : '2px solid hsl(var(--bg-sidebar-primary))'};
`;
